import {Box, Button, Modal, Paper, Stack, styled, TextField, Typography} from "@mui/material";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import {useState} from "react";
import Toasty from "../../../theme/components/Toasty";
import {changePersonalInformation} from "../../../lib/services/drive";
import {setUserData} from "../../../lib/services/jwtService";
import {useUser} from "../../../lib/hooks";

const CompleteInfoModal = (props) => {

    const { onClose, ...restProps} = props;

    const user = useUser();
    const [inputsData, setInputsData] = useState(({
        firstName: '',
        lastName: '',
    }));
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleInputChange = (e) => {
        const {target: {value, name}} = e;
        setInputsData({...inputsData, [name]: value});
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setPending(true);
        try {
            const {data} = await changePersonalInformation(inputsData);
            if (data?.isSuccess) {
                setSuccess(true);
                const newUser = {...user};
                newUser.firstName = inputsData.firstName;
                newUser.lastName = inputsData.lastName;
                setUserData(JSON.stringify(newUser));
                if (data.successMessage) Toasty.success(data.successMessage);
                window.location.reload();
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }

    return (
        <StyledModal onClose={onClose} {...restProps}>
            <Paper elevation={25} sx={{ width: {xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: {xs: "90%", lg: "85%", xl: "75%", xxl: "65%"}, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                <Typography textAlign="center" fontWeight={500}>لطفا اطلاعات خود را تکمیل کنید</Typography>
                <Stack mt={3} component="form" onSubmit={handleSubmit} spacing={2}>
                    <TextField
                        value={inputsData.firstName} onChange={handleInputChange}
                        label="نام" placeholder="لطفا نام خود را وارد کنید"
                        name="firstName" fullWidth required/>
                    <TextField
                        value={inputsData.lastName} onChange={handleInputChange}
                        label="نام خانوادگی" placeholder="لطفا نام خانوادگی خود را وارد کنید"
                        name="lastName" fullWidth required/>
                    <Box>
                        <LoadingButton
                            loading={pending}
                            type='submit' success={success}
                            fullWidth variant="contained"
                            sx={{ py: 1.5 }} disableElevation>ثبت</LoadingButton>
                        <Button onClick={onClose} fullWidth variant="outlined" sx={{ mt: 1.5, py: 1.5 }}>فعلا نه</Button>
                    </Box>
                </Stack>
            </Paper>
        </StyledModal>
    )
}
export default CompleteInfoModal;

const StyledModal = styled(Modal)(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));